import React, {FC} from 'react';
import styled from 'styled-components';

import {fontSizes, fontWeights} from '../../../../../../libs/shared/ui/src/styles/fontStyles';
import {ellipsis} from '../../../../../../libs/shared/ui/src/styles/mixins';

/*
 * Style.
 */

const StyledNameDiv = styled.div`
  grid-area: name;
  align-self: end;

  color: ${(p) => p.theme.greys.shade80};
  font-size: ${fontSizes.medium};
  font-weight: ${fontWeights.semibold};

  ${ellipsis()};
`;

/*
 * Component.
 */

export const FrameCardName: FC = ({children}) => <StyledNameDiv>{children}</StyledNameDiv>;
